import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Checkbox } from 'antd';
import type { ToolWithCount } from '@/components/Settings/DataExtraction/Content/hooks/useHandleTools';
import * as S from '../styles';

interface ErgonomicToolProps {
	tool: ToolWithCount;
}

export function ErgonomicTool({ tool }: Readonly<ErgonomicToolProps>) {
	const isDisabled = tool.count <= 0 || !tool.count;

	return (
		<Checkbox value={tool.ergonomic_tool_id} disabled={isDisabled}>
			<S.StyledCheckboxContent>
				<S.ToolContent>
					<S.LeftContent>
						{tool.icon && <S.IconWrapper>{tool.icon}</S.IconWrapper>}
						<S.NameWrapper>{I18n.get(tool.formatted_name as string)}</S.NameWrapper>
					</S.LeftContent>
					<S.CustomReportsSpan>{tool.count || 0}</S.CustomReportsSpan>
				</S.ToolContent>
			</S.StyledCheckboxContent>
		</Checkbox>
	);
}
